<template>
    <BaseLayout>
        <Hero
            :cover="constants.covers.contact"
            :background="constants.covers.contact"
            :heading="siteContent.contactUs"
            :subheading="siteContent.weAreHereToHelp"/>
        <ul class="content">
            <li class="inquiry">
                <Heading :h="3" size="m">
                    {{ siteContent.businessInquiries }}
                </Heading>
                <Heading :h="4" size="s">
                    Lorant Toth
                </Heading>
                <p class="description">
                    {{ siteContent.businessSolutions }}
                </p>
                <a class="email" href="mailto:lorant@creatillo.com">
                    <Icon class="mailIcon"
                        icon="email"
                        size="m"
                        appearance="inherit"/>
                        lorant@creatillo.com
                </a>
            </li>
            <li class="inquiry">
                <Heading :h="3" size="m">
                    {{ siteContent.supportInquiries }}
                </Heading>
                <Heading :h="4" size="s">
                    {{ siteContent.supportTeam }}
                </Heading>
                <p class="description">
                    {{ siteContent.supportSolutions }}
                </p>
                <a class="email" href="mailto:support@creatillo.com">
                    <Icon class="mailIcon"
                        icon="email"
                        size="m"
                        appearance="inherit"/>
                        support@creatillo.com
                </a>
            </li>
        </ul>
    </BaseLayout>
</template>

<script>
    import BaseLayout from '@/components/layout/main/BaseLayout'
    import Hero       from '@/components/layout/main/Hero'

    export default {
        name: 'Contact',
        components: {
            BaseLayout,
            Hero
        },
        metaInfo() {
            if(this.preferences.language === 'hu') {
                return {
                    title: 'Kapcsolatfelvétel | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Mindig állunk rendelkezésedre, amikor szükséged van ránk!' }
                    ]
                }
            } else {
                return {
                    title: 'Contact Us | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'We\'re always here to help when you need us.' }
                    ]
                }
            }
        }
    }
</script>


<style scoped lang="scss">
    @import '../scss/variables';

    .h3 {
        margin: 0 0 0.75rem 0;
    }

    .h4 {
        margin: 0;
    }

    .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 1rem 4rem;
        margin: 1rem 0 0 0;
    }

    .inquiry {
        list-style: none;
        margin: 0;
        padding: 1.5rem 2rem;
        background: var(--color-white-40);
        border-radius: 1rem;
        margin-bottom: 1rem;
    }

    .email {
        display: flex;
        width: fit-content;
        align-items: center;
        font-size: 1rem;
    }

    .mailIcon {
        margin-right: 0.5rem;
    }

    .description {
        margin: 0 0 0.5rem 0;
        font-size: 1.15rem;
        color: var(--color-grey-600);
    }

    @media all and (max-width: 1200px) {
        .content {
            padding: 0 2rem;
        }
    }

    @media all and (max-width: 640px) {
        .content {
            padding: 0 1rem;
        }
    }
</style>